
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"48","height":"49","viewBox":"0 0 48 49","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"id":"XLogo"}},[_c('path',{attrs:{"id":"Vector","d":"M40.266 40.39L28.5285 21.9437L40.1104 9.20309C40.3723 8.90782 40.5073 8.5212 40.4861 8.12706C40.4649 7.73293 40.2892 7.36303 39.9971 7.09757C39.705 6.8321 39.32 6.69248 38.9257 6.70895C38.5313 6.72543 38.1593 6.89668 37.8904 7.18559L26.8579 19.3206L19.266 7.38996C19.1306 7.17688 18.9437 7.00141 18.7224 6.87981C18.5012 6.75821 18.2528 6.69441 18.0004 6.69434H9.00038C8.73143 6.69421 8.46739 6.76639 8.23592 6.90332C8.00444 7.04026 7.81404 7.23691 7.68465 7.47269C7.55526 7.70847 7.49164 7.9747 7.50045 8.2435C7.50927 8.5123 7.59019 8.77379 7.73475 9.00059L19.4723 27.445L7.89038 40.195C7.75513 40.3402 7.65006 40.5109 7.58126 40.6971C7.51246 40.8833 7.4813 41.0813 7.48959 41.2796C7.49787 41.478 7.54544 41.6727 7.62953 41.8525C7.71362 42.0323 7.83256 42.1936 7.97946 42.3271C8.12636 42.4606 8.29829 42.5636 8.48529 42.6302C8.6723 42.6967 8.87065 42.7255 9.06886 42.7149C9.26707 42.7042 9.46119 42.6543 9.63998 42.5681C9.81876 42.4818 9.97865 42.3609 10.1104 42.2125L21.1429 30.0775L28.7348 42.0081C28.8712 42.2194 29.0587 42.3931 29.2799 42.513C29.501 42.6329 29.7488 42.6953 30.0004 42.6943H39.0004C39.269 42.6943 39.5327 42.622 39.7639 42.4852C39.9951 42.3483 40.1853 42.1519 40.3147 41.9164C40.444 41.681 40.5077 41.4151 40.4992 41.1465C40.4906 40.878 40.4101 40.6167 40.266 40.39ZM30.8235 39.6943L11.7323 9.69434H17.1698L36.2685 39.6943H30.8235Z","fill":"currentColor"}})])])
          )
        }
      }
    